import script from "./UnemployedDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./UnemployedDetails.vue?vue&type=script&setup=true&lang=js"

import "./UnemployedDetails.vue?vue&type=style&index=0&id=76e98bbb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76e98bbb"]])

export default __exports__